import { render, staticRenderFns } from "./SuccessPaid.vue?vue&type=template&id=b1ed94b4&scoped=true&"
import script from "./SuccessPaid.vue?vue&type=script&lang=js&"
export * from "./SuccessPaid.vue?vue&type=script&lang=js&"
import style0 from "./SuccessPaid.vue?vue&type=style&index=0&id=b1ed94b4&prod&lang=scss&"
import style1 from "./SuccessPaid.vue?vue&type=style&index=1&id=b1ed94b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ed94b4",
  null
  
)

export default component.exports